export default () => ({
    type: "DATA_RETRIEVAL_IN_PROGRESS",
    data: true
});
